import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, orderBy, onSnapshot, limit, getDocs } from "firebase/firestore";
import "../styles/DisplayObs.css";

function DisplayObs() {
  const [comments, setComments] = useState([]);
  const [recent10, setRecent10] = useState([]);
  const [users, setUsers] = useState([]);
  const [popupImage, setPopupImage] = useState(null);

  // Fetch Observations
  useEffect(() => {
    const commentsRef = collection(db, "observations");
    const q = query(commentsRef, orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const commentsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setComments(commentsData);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
  const fetchUsers = async () => {
    const usersRef = collection(db, "users"); // adjust collection name if needed
    const snapshot = await getDocs(usersRef);
    const allUsers = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setUsers(allUsers);
  };

  fetchUsers();
}, []);

  // Fetch last 10 QR logs
useEffect(() => {
  const fetchRecent10 = async () => {
    const qrRef = collection(db, "reviews");
    const q = query(qrRef, orderBy("createdAt", "desc"), limit(50));
    const snapshot = await getDocs(q);
    const logs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    setRecent10(logs); // <-- store ALL logs
  };

  fetchRecent10();
}, []);

  // Convert Firestore timestamp to readable time
  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 60) return "Just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} h`;
    const days = Math.floor(hours / 24);
    return `${days} d`;
  };

  // Group comments by email
  const groupedComments = comments.reduce((acc, c) => {
    const email = c.userEmail?.split("@")[0] || "Unknown";
    if (!acc[email]) acc[email] = [];
    acc[email].push(c);
    return acc;
  }, {});

  return (
    <div className="display-root">
      <h3>Observations 📝</h3>
      {comments.length > 0 ? (
        <ul className="display-comment-list">
          {Object.entries(groupedComments).map(([email, userComments]) => (
            <li key={email} className="display-comment-item">
              <span className="display-comment-email">{email}</span>
              {userComments.map((c, index) => (
                <div key={index} className="display-comment-row">
                  <p className="display-comment-text">{c.text}</p>
                  <span className="display-comment-date">
                    {c.updatedAt?.toDate
                      ? timeAgo(c.updatedAt.toDate())
                      : c.createdAt?.toDate
                      ? timeAgo(c.createdAt.toDate())
                      : "Just now"}
                  </span>
                  {c.images && c.images.length > 0 && (
                          <div className="comment-images">
                            {c.images.map((url, i) => (
                              <img
                                key={i}
                                src={url}
                                alt={`comment-${i}`}
                                className="comment-img"
                                onClick={() => setPopupImage(url)}
                                style={{ cursor: "pointer" }}
                              />
                            ))}
                          </div>
                        )}
                </div>
              ))}
            </li>
          ))}
        </ul>
      ) : (
        <p>No observations yet.</p>
      )}

        {/* 🔹 IMAGE POPUP */}
        {popupImage && (
          <div
            className="image-popup"
            onClick={() => setPopupImage(null)} // close on click
          >
            <img src={popupImage} alt="popup" className="popup-img" />
          </div>
        )}

      <h3>Qr Logs ☑️</h3>
      {recent10.length > 0 ? (
        <ul className="display-comment-list">
          {(() => {
            // Filter out security users
            const nonSecurityLogs = recent10.filter((log) => {
              const user = users.find((u) => u.email === log.userEmail);
              return user?.role?.toLowerCase() !== "security";
            });

            // Group remaining logs by email
            const groupedQrLogs = nonSecurityLogs.reduce((acc, log) => {
              const email = log.userEmail?.split("@")[0] || "Unknown";
              if (!acc[email]) acc[email] = [];
              acc[email].push(log);
              return acc;
            }, {});

            return Object.entries(groupedQrLogs).map(([email, logs]) => (
              <li key={email} className="display-comment-item">
                <span className="display-comment-email">{email}</span>
                {logs.map((log, index) => {
                  const logDate = log.createdAt?.toDate ? log.createdAt.toDate() : null;
                  return (

                    <div key={index} className="display-comment-row">

                     {(log.issueHotel || log.issueMaintenance) && (
                          <div className="display-comment-row">
                            <p className="display-comment-text">
                              {/* Show QR Data first */}
                              {log.qrData && <span className="qr-value">{log.qrData}</span>}

                              {/* Separator only if there’s an issue */}
                              {log.qrData && log.issueHotel && " | "}

                              {/* Hotel issue */}
                              {log.issueHotel && (
                                <><span className="issue-hotel">{log.issueHotel}</span></>
                              )}

                              {/* Separator only if both hotel and maintenance issues exist */}
                              {log.issueHotel && log.issueMaintenance && " | "}

                              {/* Maintenance issue */}
                              {log.issueMaintenance && (
                                <><span className="issue-hotel">{log.issueMaintenance}</span></>
                              )}

                              {/* Date at the end */}
                              {log.createdAt && " | "}
                              {log.createdAt && (
                                <span className="display-comment-date">{timeAgo(log.createdAt.toDate())}</span>
                              )}
                            </p>

                            {/* Display date in timeAgo format only if there is any issue */}
                            {/* {(log.issueHotel || log.issueMaintenance) && logDate && (
                              <span className="display-comment-date">
                                {timeAgo(logDate)}
                              </span>
                            )} */}
                          </div>
                        )}

                    </div>
                  );
                })}
              </li>
            ));
          })()}
        </ul>
      ) : (
        <p>No QR logs yet.</p>
      )}

      <h3>Security Logs 🪪</h3>
        {recent10.length > 0 ? (
          <ul className="display-comment-list">
            {(() => {
              // 🔹 Filter only security users
              const securityLogs = recent10.filter((log) => {
                const user = users.find((u) => u.email === log.userEmail);
                return user?.role?.toLowerCase() === "security";
              });

              // 🔹 Group by email
              const groupedSecurityLogs = securityLogs.reduce((acc, log) => {
                const email = log.userEmail?.split("@")[0] || "Unknown";
                if (!acc[email]) acc[email] = [];
                acc[email].push(log);
                return acc;
              }, {});

              // 🔹 Render grouped logs
              return Object.entries(groupedSecurityLogs).map(([email, logs]) => (
                <li key={email} className="display-comment-item">
                  <span className="display-comment-email">{email}</span>
                  {logs.map((log, index) => {
                    const logDate = log.createdAt?.toDate ? log.createdAt.toDate() : null;
                    return (
                      <div key={index} className="display-comment-row">
                        <p className="display-comment-text">
                          {/* QR Detail */}
                          {log.qrData && <span className="qr-value"> {log.qrData}</span>}

                          {/* Checked time */}
                          {logDate && (
                            <> | <span className="display-comment-date"> {timeAgo(logDate)}</span></>
                          )}

                          {/* Issues or No Issues */}
                          {log.issueHotel || log.issueMaintenance ? (
                            <>
                              {log.issueHotel && (
                                <> |  <span className="issue-hotel">{log.issueHotel}</span></>
                              )}
                              {log.issueMaintenance && (
                                <> |  <span className="issue-hotel">{log.issueMaintenance}</span></>
                              )}
                            </>
                          ) : (
                            <> | <span className="no-issues">No Issues</span></>
                          )}
                        </p>
                      </div>
                    );
                  })}
                </li>
              ));
            })()}
          </ul>
        ) : (
          <p>No Security logs yet.</p>
        )}

    </div>
  );
}

export default DisplayObs;
